import { prefixerT } from './common'

export const ROUTE_GESTION_GUIA_MOVILIZACION = prefixerT('gestionGuiaMovilizacion')
export const ROUTE_GUIA_MOVILIZACION = prefixerT('guiaMovilizacion')
export const ROUTE_GESTION_ALCANCE_HIELO = prefixerT('gestionAlcanceHielo')
export const ROUTE_ALCANCE_HIELO = prefixerT('alcanceHielo')
export const ROUTE_ALCANCE_VARIOS = prefixerT('alcanceVarios')
export const ROUTE_CONCILIACION_GUIAS = prefixerT('conciliacionGuias')
export const ROUTE_CONCILIACION_GUIAS_HIELO = prefixerT('conciliacionGuiasHielo')
export const ROUTE_CONCILIACION_ALCANCES = prefixerT('conciliacionAlcances')
export const ROUTE_CIERRE_MASIVO_CONCILIACION = prefixerT('cierreMasivoConciliacion')
export const ROUTE_APROBACION_APERTURA_CONCILIACION = prefixerT('aprobacionAperturaConciliacion')
export const ROUTE_GESTION_CONCILIACION = prefixerT('gestionConciliacion')
export const ROUTE_CUSTODIO_GUIA_MOVILIZACION = prefixerT('custodioGuiaMovilizacion')
export const ROUTE_CREAR_CUSTODIO = prefixerT('crearCustodio')
export const ROUTE_GESTION_CUSTODIO = prefixerT('gestionCustodio')
